export enum BUTTON_TYPES {
  SMALL_ICON_BTN = 'SMALL_ICON_BTN',
  MEDIUM_ICON_BTN = 'MEDIUM_ICON_BTN',
  TAG_BTN = 'TAG_BTN',
}
